import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { injectIntl, intlShape } from 'react-intl'
import { selectPlanningSearchPhrase } from './selectors'
import { setPlanningSearchPhrase } from './actions'
import { compose } from 'redux'

const PlanSearch = ({ phrase, onPhraseChange, intl }) => {
  return (
    <input
      value={phrase}
      onChange={(e) => onPhraseChange(e.target.value)}
      placeholder={intl.formatMessage({ id: 'searchPrompt' })}
      style={{
        border: 'none',
        outline: 0,
        marginLeft: 10,
        background: '#F2F2F2',
        padding: '5px 10px',
        fontWeight: 'normal',
        fontSize: '1rem',
        color: '#666666',
        width: 250
      }}
    />
  )
}

const mapStateToProps = (state) => {
  return {
    phrase: selectPlanningSearchPhrase(state)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onPhraseChange: (phrase) => {
      dispatch(setPlanningSearchPhrase(phrase))
    }
  }
}

PlanSearch.propTypes = {
  phrase: PropTypes.string,
  onPhraseChange: PropTypes.func,
  intl: intlShape.isRequired
}

export default compose(
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps)
)(PlanSearch)
